import { action } from 'typesafe-actions';
import { OrdemCargaTypes, IOrdemCarga } from './types';

export const loadRequest = (
  tipoCarga: string,
  codTransportadora: number,
  clienteRetira: boolean,
  codParcMotorista: number,
  codVeiculo: number,
  codTipVeiculo: number,
  codDestinatario: number,
  tipoWms: string,
  assoalho: string,
  nuNotas: number[]
) =>
  action(OrdemCargaTypes.LOAD_REQUEST, {
    tipoCarga,
    codTransportadora,
    clienteRetira,
    codParcMotorista,
    codVeiculo,
    codTipVeiculo,
    codDestinatario,
    tipoWms,
    assoalho,
    nuNotas,
  });
export const loadSuccess = (data: IOrdemCarga[]) => action(OrdemCargaTypes.LOAD_SUCCESS, { data });
export const loadFailure = () => action(OrdemCargaTypes.LOAD_FAILURE, {});

export const cleanOrdemCarga = () => action(OrdemCargaTypes.CLEAN_ORDEMCARGA);
